<template>
    <div id="discussion" class="discussion">
        <DiscussionTool :product-id="productId as (number | undefined)" :category-id="categoryId as (number | undefined)" />
        <PostsList
            v-if="posts && posts.length > 0"
            :posts="posts"
            :search-queries="searchQueries"
            :category-id="categoryId as (number | undefined)"
        />
        <SkeletonDiscussionPostSkeleton v-if="!loaded && !loadImmediately" />
        <HelpCenter v-if="showAddQuestion" />
        <ModalLogin />
        <DiscussionRules />
        <Modal size="md" modal-name="thank-you-discussions" :title="$t('discussions.thankYou')"> </Modal>
    </div>
</template>

<script lang="ts" setup>
import PostsList from '~/components/objects/Discussion/Posts/PostsList.vue'
import HelpCenter from '~/components/objects/Discussion/HelpCenter.vue'
import DiscussionTool from '~/components/objects/Discussion/DiscussionTool.vue'
import ModalLogin from '~/components/objects/ModalLogin.vue'
import DiscussionRules from '~/components/objects/Discussion/Modals/DiscussionRules.vue'
import { useAuthStore } from '~/stores/auth'
import DiscussionPost from '~/models/DiscussionPost'

const props = defineProps<{
    categoryId: number | null
    productId: number | null
    showAddQuestion?: boolean
    loadImmediately?: boolean
}>()

const loaded = ref(false)
const posts = ref<DiscussionPost[]>([])
const searchQueries = ref<string[]>([])

onBeforeMount(() => {
    useNuxtApp().$bus.$on('searchQueries', (newSearchQueries: string[]) => {
        searchQueries.value = newSearchQueries
    })
    useNuxtApp().$bus.$on('openModalForLogin', () => {
        useNuxtApp().$bus.$emit('showModal', 'ask-question-login')
    })

    useNuxtApp().$bus.$on('reloadDiscussionsList', () => {
        getDiscussionsList()
    })

    useNuxtApp().$bus.$on('resetDiscussionList', () => {
        resetDiscussionList()
    })
})

onMounted(() => {
    if (!props.loadImmediately || !loaded.value) {
        getDiscussionsList()
    } else {
        loaded.value = true
    }
})

const resetDiscussionList = () => {
    loaded.value = false
    posts.value = []
}
const getDiscussionsList = async () => {
    const authStore = useAuthStore()
    const accessToken: string | null = authStore.accessToken
    posts.value = []
    posts.value = await useNuxtApp().$repository.getSelectedDiscussionsList(props.productId, props.categoryId, { accessToken })
    loaded.value = true
}

if (props.loadImmediately) {
    await getDiscussionsList()
}
</script>
